// Copyright (c) 2017 Deere & Company

import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import actions from '../../actions-list';
import filterOptions from '../../shared/constants/pip-products-filter-options';

export const updateListFilterBy = filterBy =>
    (dispatch, getState) => {

        const {pipProducts} = getState().pips.laborAdditive;

        dispatch({
            data: filterCollection(filterBy, filterOptions, pipProducts),
            type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_FILTERED
        });

        dispatch({
            filterBy,
            type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_FILTER_BY
        });

    };

export const updateListSortBy = sortBy =>
    (dispatch, getState) => {

        const {pipProductsFiltered} = getState().pips.laborAdditive;
        const {sortDirection} = getState().pips.laborAdditive.searchFilters;

        dispatch({
            data: sortCollection(sortBy, sortDirection, pipProductsFiltered),
            type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_FILTERED
        });

        dispatch({
            sortBy,
            type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SORT_BY
        });

    };

export const updateListSortDirection = sortDirection =>
    (dispatch, getState) => {

        const {pipProductsFiltered} = getState().pips.laborAdditive;
        const {sortBy} = getState().pips.laborAdditive.searchFilters;

        dispatch({
            data: sortCollection(sortBy, sortDirection, pipProductsFiltered),
            type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_FILTERED
        });

        dispatch({
            sortDirection,
            type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SORT_DIRECTION
        });

    };



// WEBPACK FOOTER //
// ./src/pip/labor-additive/action-creators/search-filters.js